<template>
  <div id="page-add-supplier">
    <vs-card>
      <div class="vx-row pt-5 px-5">
        <div class="vx-col md:w-1/2">
          <div class="vx-row ml-1 mb-1">
            <vs-input icon="icon icon-package" v-model="form.batch_name" icon-pack="feather" class="w-full mb-1" label="Batch Name" name="Batch Name" v-validate="'required'" />
            <span class="text-danger text-sm" v-show="errors.has('Batch Name')">{{ errors.first('Batch Name') }}</span>
          </div>

          <div class="vx-row ml-1 mb-1">
            <vs-input icon="icon icon-file-text" v-model="form.description" icon-pack="feather" class="w-full mb-1" label="Description" name="Description" />
            <span class="text-danger text-sm" v-show="errors.has('Description')">{{ errors.first('Description') }}</span>
          </div>

          <!-- location Dropdown -->
          <div class="vx-row ml-1 mb-1">
            <label for="location">Location Name</label>
            <select-2
              id="location"
              class="w-full mb-1"
              ref="locationList"
              :value="form.locationId"
              @input="
                (item) => {
                  this.form.locationId = item && item.value
                }
              "
              name="Location name"
              placeholder="Select Location"
              autocomplete
              newLabel="Add New Location"
              @addNew="toggleLocationModal"
              label="name"
              :ssr="true"
              :params="{ dropdownLocationId: form.locationId }"
              action="location/fetchLocations"
            />
          </div>

          <!-- Strain Dropdown -->
          <div class="vx-row ml-1 mb-1">
            <label for="strain">Strain Name</label>
            <select-2
              id="strain"
              class="w-full mb-1"
              ref="strainList"
              :value="form.strainId"
              @input="
                (item) => {
                  this.form.strainId = item && item.value
                }
              "
              name="Strain name"
              placeholder="Select Strain"
              autocomplete
              newLabel="Add New Strain"
              @addNew="toggleAddStrainModal"
              label="name"
              :ssr="true"
              :params="{ order: ['strain.id', 'ASC'], status: true, dropdownStrainId: form.strainId }"
              action="strain/getStrains"
            />
          </div>
        </div>
      </div>

      <!-- Save & Reset Button -->
      <div class="vx-row">
        <div class="vx-col w-full">
          <div class="mt-4 items-center">
            <vs-button class="mt-2 mr-2 vs-con-loading__container" id="add-user-button" type="relief" @click="save_changes" :disabled="!validateForm || loading">Add Batch</vs-button>
            <vs-button to="/batches/list" color="danger" type="relief" class="text-left">Cancel</vs-button>
          </div>
        </div>
      </div>
    </vs-card>

    <!-- add strain modal -->
    <add-strain-modal v-if="isAddStrainModalMounted" :showModal.sync="isAddStrainModalShow" @updateList="updateStrainList" />

    <!-- add location modal -->
    <add-location-modal v-if="isAddLocationModalMounted" :showModal.sync="isAddLocationModalShow" @updateList="updateLocationList" />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Select2 from '@/components/custom/form-elements/Select2.vue'
import AddStrainModal from '@/views/strains/AddStrain'
import AddLocationModal from '@/views/location/AddLocation'

export default {
  name: 'CreateBatch',

  components: {
    Select2,
    AddStrainModal,
    AddLocationModal
  },

  data: () => ({
    loading: false,

    //add strain
    isAddStrainModalMounted: false,
    isAddStrainModalShow: false,

    //location add
    isAddLocationModalMounted: false,
    isAddLocationModalShow: false,
    form: {
      batch_name: '',
      description: '',
      locationId: null,
      strainId: null
    }
  }),

  computed: {
    ...mapState('permission', ['roles']),
    ...mapState('auth', ['user', 'permissions']),
    validateForm() {
      return !this.errors.any()
    }
  },

  methods: {
    async save_changes() {
      if (!(await this.$validator.validate())) {
        return false
      }

      this.loading = true
      this.$store
        .dispatch('batch/insert', this.form)
        .then(({ data }) => {
          this.loading = false

          this.$router.push({
            name: 'create-batch-plant',
            params: {
              batchId: data.batch.id
            }
          })

          this.$vs.notify({
            title: 'Success',
            text: data.message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'success'
          })
        })
        .catch((err) => {
          const { message } = err
          this.loading = false
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            color: 'danger'
          })
        })
    },

    updateStrainList(data) {
      this.isActive = true
      this.form.strainId = data.id

      this.$nextTick(() => {
        this.$refs.strainList.getOptions()
      })
    },

    updateLocationList(data) {
      this.isActive = true
      this.form.locationId = data.id

      this.$nextTick(() => {
        this.$refs.locationList.getOptions()
      })
    },

    // toggle track item modal
    toggleAddStrainModal() {
      this.isAddStrainModalMounted = true
      this.isAddStrainModalShow = true
    },

    // toggle track item modal
    toggleLocationModal() {
      this.isAddLocationModalMounted = true
      this.isAddLocationModalShow = true
    }
  },

  watch: {
    loading() {
      if (this.loading) {
        this.$vs.loading({
          container: '#add-user-button',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#add-user-button > .con-vs-loading')
      }
    },

    isAddStrainModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddStrainModalMounted = false
          }, 0)
        }
      }
    },

    isAddLocationModalShow: {
      immediate: true,
      handler(newVal) {
        if (!newVal) {
          setTimeout(() => {
            this.isAddLocationModalMounted = false
          }, 0)
        }
      }
    }
  },

  beforeRouteLeave(_, __, next) {
    this.isAddStrainModalShow = false
    this.isAddLocationModalShow = false
    next()
  }
}
</script>
